{
  "en": {
    "form": {
      "actions": {
        "cancel": "Cancel",
        "clear": "Clear",
        "closeFullPage": "Close full page",
        "copyText": "Click to copy text",
        "create_and_send_to_customer": "Create and send to customer",
        "create_and_share": "Create and share with customer",
        "create_and_share_partners_only": "Create and share with partner(s)",
        "create_and_share_with_partners": "Create and share with customer and partner(s)",
        "next": "Next",
        "only_create": "Only create",
        "openFullPage": "Open in full page",
        "save": "Save",
        "saveChanges": "Save changes",
        "search": "Search...",
        "send": "Send",
        "send_and_create_another": "Send and create another",
        "send_to_customer": "Send to customer",
        "share_with_customer": "Share with customer",
        "submit": "Submit",
        "submit_and_create_another": "Submit and create another"
      },
      "back": "Previous step",
      "labels": {
        "columns": "Columns",
        "from": "From",
        "no_results": "No results",
        "optional": "(optional)",
        "to": "To"
      },
      "notifications": {
        "textHasBeenCopied": "Text has been copied"
      },
      "password": "Password",
      "shortcuts": {
        "save_mac": "⌘ + Enter to save",
        "save_windows": "Ctrl + Enter to save",
        "send_mac": "⌘ + Enter to send",
        "send_windows": "Ctrl + Enter to send"
      },
      "steps": "Step {count} of {total}",
      "writeEmployeeNameReject": "Write <i><b>{employeeName}</b></i> to continue."
    }
  }
}
